'use client';

import { useGardenPlannerStore } from '@shared/store/useGardenPlannerStore';
import { AvailabilityToolContainer } from '@modules/garden-planner/containers/sidebar/availability_tool_container';
import { CellSettingsToolContainer } from '@modules/garden-planner/containers/sidebar/cell_settings_tool_container';
import { ClearPlantsToolContainer } from '@modules/garden-planner/containers/sidebar/clear_plants_tool_container';
import { GridControlsContainer } from '@modules/garden-planner/containers/sidebar/grid_controls_container';
import { PlantSelectionToolContainer } from '@modules/garden-planner/containers/sidebar/plant_selection_tool_container';
import { ShareButtonContainer } from '@modules/garden-planner/containers/sidebar/share_button_container';
import type { GardenPlannerViews } from '@modules/garden-planner/garden_planner_views';

interface SidebarContainerProps {
  views: GardenPlannerViews;
  onNavigateBack: () => void;
}

export function SidebarContainer({ views, onNavigateBack }: SidebarContainerProps) {
  const { SidebarView } = views;
  const isSidebarOpen = useGardenPlannerStore((state) => state.isSidebarOpen);
  const setIsSidebarOpen = useGardenPlannerStore((state) => state.setIsSidebarOpen);

  return (
    <SidebarView
      isSidebarOpen={isSidebarOpen}
      onCloseSidebar={() => setIsSidebarOpen(false)}
      onNavigateBack={onNavigateBack}
      shareButton={<ShareButtonContainer views={views} />}
      gardenTools={
        <>
          <PlantSelectionToolContainer views={views} />
          <AvailabilityToolContainer views={views} />
          <CellSettingsToolContainer views={views} />
          <ClearPlantsToolContainer views={views} />
        </>
      }
      gridControls={<GridControlsContainer views={views} />}
    />
  );
}
